if(typeof axios === 'undefined') {var e = new Error("Cannot find module \"axios\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 526
// module chunks = 23